// @flow

export function isAndroid(): boolean {
  return Boolean(navigator.userAgent.match(/Android/i));
}
